<template>
  <v-app>
    <Home/>
  </v-app>
</template>

<script>
 import Home from "@/components/Home";

  export default {
    components: {
      Home,
    },
  }
</script>

